import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filtersgeneClass',
  title: {
    id: 'omicsExplorer.filtersgeneClass',
    defaultMessage: 'Gene Class',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'biotype',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filtersgeneClass.proteinCoding',
        searchValue: 'protein coding,nonsense mediated decay',
        intlLabel: {
          id: 'omicsExplorer.filtersgeneClass.proteinCoding',
          defaultMessage: 'Protein Coding',
        },
        informationText: {
          id: 'omicsExplorer.filtersgeneClass.informationText.proteinCoding',
          defaultMessage: 'protein coding, nonsense mediated decay',
        },
      },
      {
        id: 'omicsExplorer.filtersgeneClass.pseudogene',
        searchValue:
          'pseudogene,unprocessed pseudogene,polymorphic pseudogene,unitary pseudogene,transcribed unprocessed pseudogene,transcribed processed pseudogene, IG pseudogene',
        intlLabel: {
          id: 'omicsExplorer.filtersgeneClass.pseudogene',
          defaultMessage: 'Pseudogene',
        },
        informationText: {
          id: 'omicsExplorer.filtersgeneClass.informationText.pseudogene',
          defaultMessage:
            'pseudogene, unprocessed pseudogene, polymorphic pseudogene, unitary pseudogene, transcribed unprocessed pseudogene, transcribed processed pseudogene, IG pseudogene',
        },
      },
      {
        id: 'omicsExplorer.filtersgeneClass.microRNA',
        searchValue: 'micro RNA',
        intlLabel: {
          id: 'omicsExplorer.filtersgeneClass.microRNA',
          defaultMessage: 'Micro RNA',
        },
        informationText: {
          id: 'omicsExplorer.filtersgeneClass.informationText.microRNA',
          defaultMessage: 'micro RNA',
        },
      },
      {
        id: 'omicsExplorer.filtersgeneClass.shortNcRNA',
        searchValue:
          'piRNA,rRNA,siRNA,snRNA,snoRNA,tRNA,scaRNA,vaultRNA,sRNA,misc RNA',
        intlLabel: {
          id: 'omicsExplorer.filtersgeneClass.shortNcRNA',
          defaultMessage: 'Short ncRNA',
        },
        informationText: {
          id: 'omicsExplorer.filtersgeneClass.informationText.shortNcRNA',
          defaultMessage:
            'piRNA, rRNA, siRNA, snRNA, snoRNA, tRNA, scaRNA, vaultRNA, sRNA, misc RNA',
        },
      },
      {
        id: 'omicsExplorer.filtersgeneClass.longNcRNA',
        searchValue:
          'lincRNA,macro IncRNA,prime3 overlapping ncrna,antisense,retained intron,sense intronic,sense overlapping,macro IncRNA,bidirectional IncRNA',
        intlLabel: {
          id: 'omicsExplorer.filtersgeneClass.longNcRNA',
          defaultMessage: 'Long ncRNA',
        },
        informationText: {
          id: 'omicsExplorer.filtersgeneClass.informationText.longNcRNA',
          defaultMessage:
            'lincRNA, macro IncRNA, prime3 overlapping ncrna, antisense, retained intron, sense intronic, sense overlapping, macro IncRNA, bidirectional IncRNA',
        },
      },
      {
        id: 'omicsExplorer.filtersgeneClass.immunoglobulin',
        searchValue: 'IG C gene,IG D gene,IG J gene,IG V gene',
        intlLabel: {
          id: 'omicsExplorer.filtersgeneClass.immunoglobulin',
          defaultMessage: 'Immunoglobulin',
        },
        informationText: {
          id: 'omicsExplorer.filtersgeneClass.informationText.immunoglobulin',
          defaultMessage: 'IG C gene, IG D gene, IG J gene, IG V gene',
        },
      },
      {
        id: 'omicsExplorer.filtersgeneClass.tCellReceptor',
        searchValue: 'TR C gene,TR J gene, TR V gene',
        intlLabel: {
          id: 'omicsExplorer.filtersgeneClass.tCellReceptor',
          defaultMessage: 'T Cell Receptor',
        },
        informationText: {
          id: 'omicsExplorer.filtersgeneClass.informationText.tCellReceptor',
          defaultMessage: 'TR C gene, TR J gene, TR V gene',
        },
      },
    ],
  },
};
